import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const SparrowCreditContext = createContext();

export const SparrowCreditProvider = ({ children }) => {
    const [token, setToken] = useState(() => localStorage.getItem("token"));
    const baseUrl = process.env.REACT_APP_BASE_URL;

    const [creditInfo, setCreditInfo] = useState(null);
    const [creditLoading, setCreditLoading] = useState(false);
    const [creditError, setCreditError] = useState(null);

    useEffect(() => {
        const syncAuth = () => {
            setToken(localStorage.getItem("token"));
        };

        window.addEventListener("authChanged", syncAuth);
        return () => window.removeEventListener("authChanged", syncAuth);
    }, []);

    const fetchCredit = async () => {
        setCreditLoading(true);
        setCreditError(null);

        try {
            const { data } = await axios.post(`${baseUrl}/sparrow-credit`, {
                token,
            });

            setCreditInfo(data);
        } catch (err) {
            console.error("Credit Fetch Error:", err);
            setCreditError("Failed to fetch credit info");
            setCreditInfo(null);
        } finally {
            setCreditLoading(false);
        }
    };

    // Auto-load when token changes
    useEffect(() => {
        if (!token) return;
        fetchCredit();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, baseUrl]);

    return (
        <SparrowCreditContext.Provider
            value={{
                creditInfo,
                creditLoading,
                creditError,
                fetchCredit,
            }}
        >
            {children}
        </SparrowCreditContext.Provider>
    );
};

export const useSparrowCredit = () => useContext(SparrowCreditContext);
